// @angular
import { Injectable } from "@angular/core";
import {
  HttpErrorResponse
} from "@angular/common/http";
import type { HttpEvent, HttpHandler, HttpRequest } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
// Own services
import { HttpRequestService } from "./HttpRequestService.service";

/** Runs HTTP requests with route-dependent timeout and error handling. */
@Injectable({
  providedIn: "root",
})
export class HttpRequestQueueService {
  /***************************************************************************/
  // Constructor
  /***************************************************************************/

  constructor(private readonly HttpRequestService: HttpRequestService) {}

  /***************************************************************************/
  // Request interception
  /***************************************************************************/

  /** Sends a queued request with its timeout, reports backend errors, and rethrows transport errors. */
  request(
    req: HttpRequest<any>,
    next: HttpHandler,
    requestTimeout: number,
  ): Observable<HttpEvent<any>> {
    return (
      next
        .handle(req)
        // Route-dependent timeout
        .pipe(this.HttpRequestService.timeoutWhen(requestTimeout))
        // Check server response for errors
        .pipe(
          tap((event) => {
            this.HttpRequestService.httpErrorManagement(event);
          }),
        )
        .pipe(
          // Error handling for the HTTP request
          catchError((error: HttpErrorResponse) => {
            let httpError = JSON.parse(JSON.stringify(error));
            httpError.code = -1;
            this.HttpRequestService.getErrorText(httpError);
            return throwError(() => error);
          }),
        )
    );
  }
}
